/**
 * auth-service 連線設定：只放 URL 與一個 transport 實例（照 atlas-board 的做法）。
 *
 * transport 由 `@tpte/auth-ui` 提供（端點路徑、CSRF header、cookie 語意都只在套件裡），
 * 本專案不再自己刻一份。session 存在 HttpOnly cookie（`vm_session`），
 * 由 transport 以 `credentials: "include"` 跨站帶回，前端不碰憑證本身。
 *
 * `AUTH_SERVICE_URL` 走環境變數（build-time `VITE_AUTH_SERVICE_URL`），
 * 沒設定就退回已上線的 vm-auth-service——與 atlas-board 同一個服務、同一個帳號。
 */
import { createHttpTransport } from '@tpte/auth-ui';

const DEFAULT_AUTH_SERVICE_URL = 'https://vm-auth-service.a7272563.workers.dev';

const configured = (import.meta.env.VITE_AUTH_SERVICE_URL as string | undefined)?.trim();

export const AUTH_SERVICE_URL =
  configured !== undefined && configured.length > 0 ? configured : DEFAULT_AUTH_SERVICE_URL;

export const transport = createHttpTransport(AUTH_SERVICE_URL);
